export const tokens = {
    gap: 16,
    minColumn: {
        // These sizes were previously `280` and `340`, but had to
        // be reduced in order to mitigate problematic grid sizing.
        compact: 268,
        default: 298,
    },
    // This is temporary until we can implement a better
    // Pod's page layout. Currently, the `GlobalNav` and
    // `Filters Sidebar` are restricting real estate.
    itemMaxWidth: 400,
};
